//Materialize
import '../stylus/alquileres.styl'

//FontAwsome
import '../libs/fontawsome/css/fontawesome-all.min.css'
import '../libs/fonda-paisa/style.css'
// modernizr
import '../libs/modernizr/modernizr-custom.js'

import {espCalendar, createCarrousel, cambioSede, getItem} from './include/global.js'

let carousel
$(document).ready(function(){
	cambioCategoria($('[data-id_cat]').first().attr('data-id_cat'))

	$('[data-id_cat]').on('click', function(event){
		event.preventDefault()
		cambioCategoria($(this).attr('data-id_cat'))
	})
})

function cambioCategoria(idCat){
	$('[data-id_cat]').not($('[data-id_cat = "' + idCat + '"]')).removeClass('active')
	$('[data-id_cat = "' + idCat + '"]').addClass('active')

	let categoria = getItem(categorias, idCat, 'idCat')	
	if(carousel != undefined){
		var instance = M.Carousel.getInstance(carousel);
		instance.destroy();
	}
	createCarrousel($('.carousel.carousel-slider:not(#big-banner)'), categoria.fotos)
	carousel = $('.carousel.carousel-slider:not(#big-banner)').carousel({
		fullWidth: true,
		indicators: true
	});
	
	let $descripcion 	= $('.descripcion')
	$descripcion.text(categoria.descrCat)
	
}



// WEBPACK FOOTER //
// ./src/js/alquileres.js